import { Component } from '@angular/core';
import { TableComponent } from '../../../../shared/components/table/table.component';
import { FormsModule } from '@angular/forms';
import { Fila } from '../../../../shared/models/fila';
import { TableHeader } from '../../../../shared/models/table-header';
import { ToastService } from '../../../../shared/services/toast.service';
import { FilaService } from '../../../../shared/services/fila.service';
import { MatDialog } from '@angular/material/dialog';
import { FilaFilter } from '../../models/fila-filter';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';
import { DialogLcbSegurancaComponent } from './dialog-lcb-seguranca/dialog-lcb-seguranca.component';
import { FaseId } from '../../../../shared/enums/fase.enum';
import { LocalId } from '../../../../shared/enums/local.enum';
import { RecebimentoService } from '../../../../shared/services/recebimento.service';

@Component({
  selector: 'app-lcb-fila-seguranca',
  imports: [TableComponent, FormsModule],
  templateUrl: './lcb-fila-seguranca.component.html',
  styleUrl: './lcb-fila-seguranca.component.scss',
})
export class LcbFilaSegurancaComponent {
  filaList: Fila[] = [];
  headers: TableHeader[] = [
    { value: 'recebimento.senha', label: 'Senha' },
    { value: 'dataEntrada', label: 'Data Entrada', pipe: 'datetime' },
    { value: 'dataChamada', label: 'Data Chamada', pipe: 'datetime' },
    { value: 'recebimento.milkrun', label: 'Milk Run' },
    { value: 'recebimento.critico', label: 'Crítico' },
    { value: 'recebimento.subidaDireta', label: 'Subida Direta - LOTS' },
  ];

  constructor(
    private toast: ToastService,
    private service: FilaService,
    private recebimentoService: RecebimentoService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadFilaList();
  }

  loadFilaList() {
    const filter: FilaFilter = {
      faseId: FaseId.SEGURANCA,
      localId: Number(LocalId.LCB),
    };

    this.service.getFiltered(filter).subscribe({
      next: (value) => {
        if (value && value.content) {
          this.filaList = [...value.content];
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] ?? 'Falha ao carregar filas.',
        );
      },
    });
  }

  edit(item: Fila) {
    const id = item.recebimentoId;

    this.recebimentoService.getSecurityDetails(id).subscribe({
      next: (result) => {
        if (result.success && result.content) {
          const data = {
            ...item,
            driverInfo: result.content,
          };

          const dialogRef = this.dialog.open(DialogLcbSegurancaComponent, {
            data: data,
          });

          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.toast.showToast(ts.success, 'Fila atualizada!');
              this.filaList = this.filaList.filter(
                (item) => item.id !== result.id,
              );
            }
          });
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error[0] || 'Erro ao buscar detalhes da segurança.',
        );
      },
    });
  }
}
